import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/index';
import { environment } from '@environments/environment';
import 'hammerjs';

if (environment.production) {
  enableProdMode();
  // stop console log from displaing in debug mode (console tab)
  window.console.log = function() {};
}

const gtmScriptElement = document.createElement('script');
const gtmNoJSElement = document.createElement('noscript');

const gtmScriptElementContent = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':  new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);})(window,document,\'script\',\'dataLayer\',\'' + environment.GTM_Code + '\');' ;
const gtmNoScriptElementContent = '<iframe src="https://www.googletagmanager.com/ns.html?id="' + environment.GTM_Code + '"height="0" width="0" style="display:none;visibility:hidden"></iframe>';

gtmScriptElement.innerHTML = gtmScriptElementContent;
gtmNoJSElement.innerHTML = gtmNoScriptElementContent;
document.head.appendChild(gtmScriptElement);
document.head.appendChild(gtmNoJSElement);

platformBrowserDynamic().bootstrapModule(AppModule);
